module.exports = __webpack_public_path__ + "img/sec9desk.17cf270b.png";